import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/partners/apple-pay-logo.svg")